import { render, staticRenderFns } from "./IndicationDetails.vue?vue&type=template&id=88d1862c&scoped=true&"
import script from "./IndicationDetails.vue?vue&type=script&lang=js&"
export * from "./IndicationDetails.vue?vue&type=script&lang=js&"
import style0 from "./IndicationDetails.vue?vue&type=style&index=0&id=88d1862c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d1862c",
  null
  
)

export default component.exports